import { Badge, BetaDataTableCell as Cell } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";

import styles from "./ConversationCell.module.css";

export interface ConversationCellProps {
  count: number;
}

export function ConversationCell({ count }: ConversationCellProps) {
  const formatOptions: Intl.NumberFormatOptions = {
    compactDisplay: "short",
    notation: "compact",
  };

  return (
    <Cell>
      <div className={styles.container}>
        <Icon name="commentConvo" color="StrokeStronger" size={16} />
        <Badge variant="neutral">
          {count.toLocaleString(undefined, formatOptions)}
        </Badge>
      </div>
    </Cell>
  );
}

ConversationCell.displayName = "ConversationCell";
